import { render } from "./ActionablesWidget.vue?vue&type=template&id=61e7ad6d&scoped=true"
import script from "./ActionablesWidget.vue?vue&type=script&lang=js"
export * from "./ActionablesWidget.vue?vue&type=script&lang=js"

import "./ActionablesWidget.vue?vue&type=style&index=0&id=61e7ad6d&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61e7ad6d"]])

export default __exports__